import { Component, OnInit,ChangeDetectorRef } from '@angular/core';
import { logbaseService } from "../../services/logbase.service";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator} from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
export interface SummaryData{
  supplierCode:any; totalPkgIdCount:any; availPkgIdCount:any; availPkgIdPer:any;
}

@Component({
  selector: 'app-po-summary',
  templateUrl: './po-summary.component.html',
  styleUrls: ['./po-summary.component.scss']
})
export class PoSummaryComponent implements OnInit {

  averagePercentage: number;
  summaryDataLength: any;
  poSumData: any[];
  summaryData: any;
  public rows: Array<any> = [];
  public columns: any 
  displayedColumns = ['supplierCode', 'totalPkgIdCount', 'availPkgIdCount', 'availPkgIdPer'];
  dataSource: MatTableDataSource<SummaryData[]>;
  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public totalItems: any;
  public config: any 
  srchValue:any;

  public data: Array<any> = [];

  constructor( private logbaseService: logbaseService,private ref: ChangeDetectorRef, private spinner: NgxSpinnerService,  private translate: TranslateService) {
    this.columns= [
      { title: this.translate.instant("SUPPLIERCODE"),name: "supplierCode",sort:''},
      { title: this.translate.instant('Package ID Count for Current PO'), name: "totalPkgIdCount"},
      { title: this.translate.instant("Available Package Information"), name: "availPkgIdCount" },
      { title: this.translate.instant("% of Available Information"), name: "availPkgIdPer"},
    ]; 
    this.config= {
      paging: true,
      sorting: { columns: this.columns },
      filtering: {filterString: ''},
      className: ['table-striped', 'table-bordered', 'ng-table_input']
    };
   }

  ngOnInit() {
    this.spinner.show();
    this.onChangeTable(this.config, true);
  }

  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].toString().match(column.filtering.filterString);
        });
      }
  
    });

    if (!config.filtering) {
      return filteredData;
    }


    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name].toString().match(this.config.filtering.filterString)) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;
    return filteredData;
  }

  public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    var pageNo;
    var sortData;
  if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = (page.page) - 1;
    }

    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }
    this.config.sorting.columns.forEach(function (value, key) {
      if (value.sort != '') {
        sortData = {
          name: value.name,
          sort: value.sort
        }
      }
    });
    var dataToSend = {
      pageNum: pageNo,
      // searchValue: this.config.filtering.filterString,
      searchValue:this.srchValue,
      size: this.itemsPerPage,
      sortColumn: sortData ? sortData.name : '',
      sortType: sortData ? sortData.sort: '',
    }

    this.logbaseService.getPoSummaryData(dataToSend)
      .subscribe(result => {
        this.summaryData = result;
        // this.summaryDataLength = this.summaryData.length;
        this.getAverage(this.summaryData);
        var partArr;
        var partsData = [];
        this.spinner.hide();
        this.summaryData.response.content.forEach(function (value, key) {
          partArr = {
            supplierCode:  value.supplierCode,
            totalPkgIdCount: value.totalPkgIdCount,
            availPkgIdCount: value.availPkgIdCount,
            availPkgIdPer: value.availPkgIdPer
          };
          partsData.push(partArr);
        });

        this.poSumData = partsData;
        this.dataSource=new MatTableDataSource<SummaryData[]>(this.poSumData)
        this.data = partsData;
        this.length = this.summaryData.response.totalElements;
        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);
        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        // this.length = sortedData.length;
        this.rerenderTable(this.config, true);
        this.ref.detectChanges();
      });
  }

  public rerenderTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }
    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }
    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
  }

  getAverage(Data){
    this.summaryDataLength = Data.response.content.length;
    var average = Data.response.content.reduce((x, info) => x + info.availPkgIdPer,0);
    this.averagePercentage = (average/this.summaryDataLength);
  }
}
